import React from 'react';

// eslint-disable-next-line @atlaskit/design-system/no-emotion-primitives -- to be migrated to @atlaskit/primitives/compiled – go/akcss
import Flex from '@atlaskit/primitives/components/flex';
import Box from '@atlaskit/primitives/box';
import { xcss } from '@atlaskit/primitives/xcss';
import Heading from '@atlaskit/heading/heading';
import ArrowLeftIcon from '@atlaskit/icon/core/arrow-left';
import IconButton from '@atlaskit/button/icon/button';

import { useGetIsMissingColumnMappingError } from '../../providers/BulkCreateContextProvider.tsx';

const headerMessageStyle = xcss({
	paddingInline: 'space.100',
	font: 'font.heading.small',
	fontWeight: 'font.weight.medium',
	paddingBottom: 'space.025',
});

export const BulkCreateNavigationHeader = ({
	children,
	onClose,
}: {
	children: React.ReactNode;
	onClose: () => void;
}): React.JSX.Element => {
	const isMissingColumnMappingError = useGetIsMissingColumnMappingError();
	return (
		<Box paddingBlockEnd="space.100">
			<Flex direction="row" alignItems="center">
				<IconButton
					icon={() => <ArrowLeftIcon label="back-icon" spacing="none" />}
					appearance="subtle"
					label="close"
					onClick={onClose}
					isDisabled={isMissingColumnMappingError}
					testId="close-bulk-issue-create-panel-button"
				/>
				<Heading size="medium" as="h2">
					<Box xcss={headerMessageStyle}>{children}</Box>
				</Heading>
			</Flex>
		</Box>
	);
};
